import Tags from '../constants/adobeTags';
import { PEOPLE_CONNECT_SELF_SOURCE } from '../constants/routes';

export const tags = Tags;

const PAGE_CATEGORY = 'account';

export const buildAdobePageName = (pagePath: string) =>
  `cvs|web|${PAGE_CATEGORY}|${pagePath.replace(/:/g, '|')}`;

export const pageLoadAnalytics = (
  pageName: string,
  guest = false,
  pageFlag?: string,
  extraData?: Record<string, string | undefined>,
  pagePath?: string
) => {
  const utagScript = document.getElementById('id-utag');
  const tagFunction = function () {
    const caregivingType = guest && (pageName === tags.confirmationPage.minorAttest || pageName === tags.confirmationPage.cancelMinorAttestModal) ? 'guest_caregiving_access' : (guest ? 'caregiving_adult_response' : 'caregiving_access');
    const path = pagePath ?? `${caregivingType}:${pageName}`;
    const analyticsData = {
      page_name: `${PAGE_CATEGORY}:${path}`,
      adobe_page_name: buildAdobePageName(path),
      page_category: PAGE_CATEGORY,
      page_flag: pageFlag,
      ...extraData
    };

    if (pageName == '') {
      analyticsData.page_name = analyticsData.page_name.slice(0, -1);
    }

    setTimeout(() => {
      if (typeof window !== 'undefined') {
        window['utag'].view(analyticsData);
      }
    }, 500);
  };

  if (utagScript) {
    utagScript.onload = function () {
      if (typeof window !== 'undefined' && window['utag']) {
        tagFunction();
      }
    };
  }
  try {
    if (typeof window !== 'undefined' && window['utag']) {
      tagFunction();
    }
  } catch (e) {
    return;
  }
};

export const preparePageLoadAnalytics = () => {
  window['utag_cfg_ovrd'] = window['utag_cfg_ovrd'] || {};
  window['utag_cfg_ovrd'].noview = true;
};

export const apiErrorAnalytics = (
  pageTag: string,
  field_error: string,
  guest = false,
  errorTag = 'error'
) => {
  const caregivingType = guest && (pageTag === tags.confirmationPage.minorAttest || pageTag === tags.confirmationPage.cancelMinorAttestModal) ? 'guest_caregiving_access' : (guest ? 'caregiving_adult_response' : 'caregiving_access');
  const data = {
    payload: {
      link_name: `custom:account:${caregivingType}:${pageTag}:${errorTag}`,
      field_errors: `${pageTag}:${field_error}`,
      site_error: 1
    }
  };
  try {
    if (typeof window !== 'undefined' && window['utag']) {
      setTimeout(() => {
        window['utag'].link(data.payload);
      }, 50);
    }
  } catch (e) {
    console.log(e);
  }
};

export const clickAnalytics = (
  pageTag?: string,
  buttonTag?: string,
  guest = false,
  event?: string
) => {
  const caregivingType = guest && (pageTag === tags.confirmationPage.minorAttest || pageTag === tags.confirmationPage.cancelMinorAttestModal) ? 'guest_caregiving_access' : (guest ? 'caregiving_adult_response' : 'caregiving_access');
  const payload = {
    link_name: `custom:account:${caregivingType}:${pageTag}:${buttonTag}`,
    ...(event && { event: '1' })
  };
  try {
    if (typeof window !== 'undefined' && window['utag']) {
      setTimeout(() => {
        window['utag'].link(payload);
      }, 1);
    }
  } catch (e) {
    console.log(e);
  }
};

export const authenticationAnalytics = (
  pageTag?: string,
  linkTag?: string,
  authType?: string,
  guest = false
) => {
  const data = {
    payload: {
      link_name: `custom:account:${
        guest ? 'caregiving_adult_response' : 'caregiving_access'
      }:${pageTag}:${linkTag}`,
      ...(authType === 'start' && { auth_start: '1' }),
      ...(authType === 'success' && { auth_success: '1' })
    }
  };
  try {
    if (typeof window !== 'undefined' && window['utag']) {
      setTimeout(() => {
        window['utag'].link(data.payload);
      }, 1);
    }
  } catch (e) {
    console.log(e);
  }
};

export const buildEntryMethod = (source: string): string =>
  source === PEOPLE_CONNECT_SELF_SOURCE ? source.toLowerCase() : `rx:${source.toLowerCase()}`;

export const buildPageFlag = (ssk: string, caregiveeType: string): string | undefined => {
  if (!ssk || !caregiveeType) return undefined;
  const sskPrefix = ssk === 'PBM' ? 'cmk' : 'rx';
  return `${sskPrefix}_${caregiveeType.toLowerCase()}`;
};

export const rawClickAnalytics = (buttonTag: string, pagePath?: string, extraData?: Record<string, string | number>) => {
  try {
    if (typeof window !== 'undefined' && window['utag']) {
      setTimeout(() => {
        window['utag'].link({
          link_name: pagePath ? `${PAGE_CATEGORY}:${pagePath}:${buttonTag}` : buttonTag,
          ...(pagePath && { adobe_page_name: buildAdobePageName(pagePath) }),
          ...extraData
        });
      }, 1);
    }
  } catch (e) {
    console.log(e);
  }
};

export const formErrorAnalytics = (
  error_keys: any,
  errors: any,
  pageTag: string,
  buttonTag: string,
  guest = false,
  errorTag = 'error'
) => {
  if (error_keys.length !== 0) {
    // for button click tagging with form errors
    clickAnalytics(pageTag, buttonTag);
    // for error tagging
    if (Object.entries(errors)) {
      const field_error = error_keys.reduce(
        (field_errors_string: string, error_key: string, index) => {
          return index === 0
            ? `${errors[`${error_key}`].message}`
            : field_errors_string + '|' + `${errors[`${error_key}`].message}`;
        },
        ''
      );
      const data = {
        type: 'link',
        payload: {
          link_name: `custom:account:${
            guest ? 'caregiving_adult_response' : 'caregiving_access'
          }:${pageTag}:${errorTag}`,
          field_errors: `${pageTag}:correct the following errors.${field_error}`,
          site_error: 1
        }
      };
      try {
        if (typeof window !== 'undefined' && window['utag']) {
          setTimeout(() => {
            window['utag'].link(data.payload);
          }, 1);
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
